import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ResponseWrapper } from '@shared';
import { Profesion } from '@shared/models';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_PROFESION = '/profesion';

@Injectable({
  providedIn: 'root',
})
export class ProfesionService {
  private readonly API_URL_PROFESION = API_URL + ENDPOINT_PROFESION;
  private http = inject(HttpClient);

  listarProfesiones(): Observable<Profesion[]> {
    return this.http.get<ResponseWrapper<Profesion[]>>(this.API_URL_PROFESION).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
